import React from 'react';
import { connect } from 'react-redux';

import { setOptions, disableOptions } from '../actions/status';
import { showNextButton } from '../actions/next';
import OptionsSelectorGroup from '../components/molecules/OptionsSelectorGroup';
import OptionsRequestSerial from '../components/molecules/OptionsRequestSerial';
import OptionsSponsoring from '../components/molecules/OptionsSponsoring';

import uniq from 'lodash/uniq';
var AppConfig = require('../config.json');

class OptionsView extends React.Component {

    constructor(props) {
      super(props);
      this.findConfiguration = this.findConfiguration.bind(this);
      this.addOption = this.addOption.bind(this);
      this.isSelected = this.isSelected.bind(this);
      this.preSelection = this.preSelection.bind(this);
      this.inputCheck = this.inputCheck.bind(this);
      this.changeSerial = this.changeSerial.bind(this);
      this.groups = {};
      this.optionItems = {};
      this.state = {
        articles: [],
        bundleId: 0,
        isset: false,
        serial: '',
        issetSerial: this.props.project.requestSerial===false,
      };
    }

    componentDidMount() {
      // if(this.props.pathname==="/"+AppConfig.links.options.url && (this.props.linkTo===AppConfig.links.options.url || this.props.linkTo==="")) {
        this.props.dispatch(showNextButton({link: AppConfig.links.payment.url, label: 'Weiter', watch: 'options', submitDelay:200}));
      // }
      this.inputCheck();
    }

    shouldComponentUpdate(nextProps, nextState) {
      return this.props.pathname===nextProps.pathname;
    }

    componentDidUpdate(prevProps, prevState) {
      if(this.state.articles!==prevState.articles || this.state.serial!==prevState.serial || this.state.issetSerial!==prevState.issetSerial || this.state.isset!==prevState.isset) {
        var count = this.props.project.data.bundles.find(this.findConfiguration).configuration.length, groups = {}, articles = [];
        var articleConfig = [];
        for(var key in this.optionItems) {
          articleConfig.push(this.optionItems[key]);
        }
        if(articleConfig.length===count && !this.state.isset) {
          this.setState({
            ...this.state,
            isset: true
          });
        } else {
          this.props.dispatch(setOptions({isset:(this.state.isset && this.state.issetSerial), articles:uniq(this.state.articles), bundleId: this.state.bundleId, articleConfig:articleConfig}));
        }
        
        
      }

    }

    preSelection(isset, articles, bundleId) {
      var articleConfig = [];
      for(var key in this.optionItems) {
        articleConfig.push(this.optionItems[key]);
      }
      this.props.dispatch(setOptions({isset:isset && this.state.issetSerial, articles:uniq(articles), bundleId: bundleId, articleConfig:articleConfig}));
    }

    changeSerial(sn) {
      this.setState({
        serial: sn,
        issetSerial: (this.props.project.requestSerial===false || sn!=="")
      });
    }

    inputCheck() {
      
        var config = this.props.project.data.bundles.find(this.findConfiguration);
        if(config!==undefined) {
          var count = config.configuration.length, singleChoices = [];
          for (var n = 0; n < config.configuration.length; n++) {
            if(config.configuration[n].choices.length===1) {
              this.groups["optionsgroup_"+n] = config.configuration[n].choices[0].article;
              this.optionItems["optionsgroup_"+n] = {configuration: n, choices: 0};
              singleChoices.push(config.configuration[n].choices[0].article);
            } else {
              for (var i = 0; i < config.configuration[n].choices.length; i++) {
                if(this.props.options.articles.indexOf(config.configuration[n].choices[i].article)!==-1) {
                  this.groups["optionsgroup_"+n] = config.configuration[n].choices[i].article;
                  this.optionItems["optionsgroup_"+n] = {configuration: n, choices: i};
                }
              }
            }
          }
          
          var optDone = (this.props.options.articles.length===count);
          this.setState({
            ...this.state,
            articles: uniq(this.props.options.articles.concat(singleChoices)),
            bundleId: this.props.bundle.id,
            isset: optDone,
            issetSerial: (this.props.project.requestSerial===false)
          });
        }
      
      // if(this.props.project.requestSerial===false) {
      //   console.warn("this.props.project.requestSerial ",this.props.project.requestSerial)
      //   this.setState({
      //     ...this.state,
      //     issetSerial: true
      //   });
      // }
    }

    addOption(group, option, id) {

      var count = this.props.project.data.bundles.find(this.findConfiguration).configuration.length, groups = {}, articles = [];
      this.optionItems[group] = {configuration: parseInt(group.replace('optionsgroup_',''), 10), choices: id};
      
      groups[group] = option.article;
      this.groups = Object.assign(this.groups,groups);

      for(var key in this.groups) {
        articles.push(this.groups[key]);
      }
      var optDone = (articles.length===count);
      this.setState({
        ...this.state,
        articles: articles,
        bundleId: this.props.bundle.id,
        isset: optDone,
      }, this.preSelection(optDone, articles, this.props.bundle.id));
      
    }

    isSelected(choice) {
      return this.state.articles.indexOf(choice.article)!==-1;
    }

    findConfiguration(bundle) { 
      return this.props.bundle.id === bundle.id;
    }

    render () {
        const bundle = this.props.project.data.bundles.find(this.findConfiguration);
        return (
          <div className="contentview options">
              <div className="groups">
                  {
                    bundle!==undefined
                    ?
                    bundle.configuration.map((config, n) => <OptionsSelectorGroup isSingleChoice={config.choices.length===1?true:false} ref={`optionsgroup_${n}`} key={`optionsgroup_${n}`} group={`optionsgroup_${n}`} config={config} onChange={this.addOption} checkSelect={this.isSelected} />)
                    :
                    null
                  }
              </div>
                { bundle.sponsoring.active && <OptionsSponsoring sponsoring={bundle.sponsoring} /> }
                { this.props.project.requestSerial && <OptionsRequestSerial onChange={this.changeSerial} /> }
          </div>
        );
    }

}



const mapStateToProps = (state) => {
  return {
    pathname: state.routing.location.pathname,
    linkTo: state.content.link,
    project: state.status.project,
    serialnum: state.status.requestSerial.sn,
    bundle: state.status.bundle,
    options: state.status.options
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsView)



// WEBPACK FOOTER //
// ./src/views/OptionsView.js